/**
 * @generated SignedSource<<2c41a172f40bf7905f3d2897336f588c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StorecastSettingsMutation$variables = {
  setName?: string | null;
  setScreenIds?: ReadonlyArray<string> | null;
  storecastId: string;
};
export type StorecastSettingsMutation$data = {
  readonly dashboard: {
    readonly setName: {
      readonly id: string;
      readonly name: string;
    };
    readonly setScreens: {
      readonly id: string;
      readonly screens: ReadonlyArray<{
        readonly id: string;
      }>;
    };
  };
};
export type StorecastSettingsMutation = {
  response: StorecastSettingsMutation$data;
  variables: StorecastSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "setName"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "setScreenIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "title",
            "variableName": "setName"
          }
        ],
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "setName",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "screenIds",
            "variableName": "setScreenIds"
          }
        ],
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "setScreens",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StorecastScreen",
            "kind": "LinkedField",
            "name": "screens",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastSettingsMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "StorecastSettingsMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "52371b9baff569595d079d65448b8266",
    "id": null,
    "metadata": {},
    "name": "StorecastSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation StorecastSettingsMutation(\n  $storecastId: ID!\n  $setName: String\n  $setScreenIds: [String!]\n) {\n  dashboard(dashboardId: $storecastId) {\n    setName(title: $setName) {\n      id\n      name\n    }\n    setScreens(screenIds: $setScreenIds) {\n      id\n      screens {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3b9e748cfb2595bf9b2d9508cf8aeb4a";

export default node;
